<div class="flex flex-col h-full w-full">
  <form (keydown.enter)="save()">
    <div class="flex flex-col gap-4 mb-4">
      <prox-field label="Image URL">
        <input pInputText name="imageUrl" [(ngModel)]="imageUrl" [pAutoFocus]="true" />
      </prox-field>
      <div class="flex flex-row gap-4">
        <prox-field label="Width">
          <input pInputText name="imageWidth" [(ngModel)]="imageWidth" (change)="onWidthChange()" />
        </prox-field>
        <prox-field label="Height">
          <input pInputText name="imageHeight" [(ngModel)]="imageHeight" (change)="onHeightChange()" />
        </prox-field>
        <div *ngIf="ratio" class="flex items-end pb-2">
          <p-checkbox name="aspect" id="aspect" [(ngModel)]="isAspect" [binary]="true"></p-checkbox>
          <label for="aspect" class="ml-2">Maintain aspect ratio</label>
        </div>
      </div>
    </div>
  </form>

  <div class="flex pt-2 items-center">
    <p-button [disabled]="!canSave()" (onClick)="save()" label="Ok" styleClass="mr-2"></p-button>
    <p-button (onClick)="cancel()" label="Cancel" styleClass="mr-2"></p-button>
    <div class="flex-grow"></div>
    <p-button icon="pi pi-question" [rounded]="true" [text]="true" [raised]="true"
      [pTooltip]="'Choose an image from the list above, OR leave the URL with ' + '{{ids}}' + ' that are resolved when the template is rendered. Type the width and height to set the size that you want the image to have in the template.'" />
  </div>
</div>
